import React from 'react';
import Theme from 'styles/theme';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import './ColorDropdown.styl';
import classnames from 'classnames';

export default class ColorDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false,
    };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.colorChanged = this.colorChanged.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  toggleOpen() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  colorChanged(color) {
    this.setState({
      opened: false,
    });
    this.props.onChange(color);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  /**
   * Event handler for mouse click.  Fires parent event if the click is outside the search results box
   */
  handleClickOutside(event) {
    if (this.colorSelect && !this.colorSelect.contains(event.target)) {
      this.setState({
        opened: false,
      });
    }
  }

  render() {
    const {selectedColor, numColors} = this.props;
    return (
      <div className="color-dropdown-container">
        <div className={classnames('color-box', 'color' + selectedColor)} onClick={this.toggleOpen}>
          <ArrowDropDown color={Theme.palette.silver} />
        </div>
        {this.state.opened && (
          <div className="color-select" ref={c => (this.colorSelect = c)}>
            {[...Array(numColors)].map((_, i) => (
              <div
                className={classnames('color-item', 'color' + i)}
                key={i}
                onClick={() => this.colorChanged(i)}></div>
            ))}
          </div>
        )}
      </div>
    );
  }
}
